/* src/services/ServicesService.js */
import apiClient from './api'

export const ServicesService = {

  // --- MAPPATURA: Backend -> Frontend ---
  mapFromApi(data) {
    return {
      id: data.id,
      name: data.name || '',
      description: data.description || '',
      price: Number(data.price) || 0,
      duration: Number(data.duration) || 0,
      selectionMode: data.selection_mode || 'any',
      checkInventory: !!data.requires_inventory_check,
      requiredSkills: data.required_skills || [],
      requiredResourceCats: data.required_resources || [],
      questions: (data.attributes || []).map(a => ({
        label: a.label || '',
        type: a.field_type || 'text',
        options: (a.options?.valori) ? a.options.valori.join(', ') : '',
        required: !!a.is_required
      })),
      hasQuestions: (data.attributes?.length > 0),
      paymentRule: data.payment_rule || null,
    };
  },

  // --- MAPPATURA: Frontend -> Backend ---
  mapToApi(serviceForm) {
    // Cerca 'payment_rule' con lo underscore, come appare nel log di 'pureData'
    const rule = serviceForm.payment_rule || serviceForm.paymentRule;
    const isOverrideActive = !!(rule && rule.type)
    console.debug("*** DEBUG: mapToApi serviceForm", JSON.stringify(serviceForm))
    console.debug("*** DEBUG: mapToApi isOverrideActive, rule, rule.type", JSON.stringify(isOverrideActive), rule, rule.type)
    console.debug("*** DEBUG: mapToApi payment_rule", JSON.stringify(serviceForm.payment_rule))
    console.debug("*** DEBUG: mapToApi serviceForm.paymentRule", JSON.stringify(serviceForm.paymentRule))

    return {
      name: serviceForm.name,
      description: serviceForm.description,
      price: serviceForm.price,
      duration: serviceForm.duration,
      selection_mode: serviceForm.selectionMode || 'any',
      requires_inventory_check: !!serviceForm.checkInventory,
      required_skills: serviceForm.requiredSkills || [],
      required_resources: serviceForm.requiredResourceCats || [],
      attributes: serviceForm.hasQuestions ? serviceForm.questions.map(q => ({
        label: q.label,
        field_type: q.type,
        is_required: !!q.required,
        options: (q.type === 'select' && q.options) 
          ? { "valori": q.options.split(',').map(s => s.trim()) } 
          : null
      })) : [],
      
      // Usa la variabile 'rule' definita sopra
      payment_rule: isOverrideActive 
        ? {
            type: rule.type,
            value: rule.value,
            unit: rule.unit
          } 
        : null,
    };
  },

  // --- OPERAZIONI API ---
  async getAll() {
    try {
      const response = await apiClient.get('catalog/services/');
      if (!Array.isArray(response.data)) {
        console.error("Il server non ha restituito un array:", response.data);
        return [];
      }
      return response.data.map(item => this.mapFromApi(item));
    } catch (error) {
      console.error("Errore nel recupero dei servizi:", error);
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await apiClient.get(`catalog/services/${id}/`);
      return this.mapFromApi(response.data);
    } catch (error) {
      console.error(`Errore nel recupero del servizio ${id}:`, error);
      throw error;
    }
  },

  async create(serviceForm) {

    const pureData = JSON.parse(JSON.stringify(serviceForm));
    const payload = this.mapToApi(pureData);
    console.log("*** DEBUG: Payload inviato in CREAZIONE:", JSON.stringify(payload));

    return await apiClient.post('catalog/services/', payload);
  },

  async update(id, serviceForm) {

    const pureData = JSON.parse(JSON.stringify(serviceForm));
    console.log("*** DEBUG: pureData:", pureData);
    const payload = this.mapToApi(pureData);
    console.log("*** DEBUG: Payload inviato ad Axios:", JSON.stringify(payload));

    return await apiClient.put(`catalog/services/${id}/`, payload);
  },

  async delete(id) {
    return await apiClient.delete(`catalog/services/${id}/`);
  }
}